<template>
  <div
    class="my-xs px-xs xs:flex grid items-center md:table-cell md:flex-none md:border-[1px] md:p-1 md:align-middle lg:whitespace-nowrap dark:border-transparent"
    :class="{
      'w-full': props.shouldFillColumn,
      'md:w-[1%]': !props.shouldFillColumn,
    }"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ shouldFillColumn: boolean }>();
</script>
